import matchMediaConst from "constant/matchmedia";
import { useCustomScreenSize } from "hoc/useScreenSize";
import { memo } from "react";
import { getRelativeImagePath } from "../../util/helper/getRelativeImagePath";
import BannerWithFallback from "../category/banner/BannerWithFallback";
import withErrorHandler from "../design-system/withErrorHandler";

function LandingPageBanner(props: any) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { bannerImages, breadcrumbs, ...rest } = props;
  const isMobile = useCustomScreenSize({
    maxWidth: matchMediaConst.XS_MAX,
  });

  return (
    <>

      <BannerWithFallback
        {...{ src: isMobile ? getRelativeImagePath(bannerImages.mobileImage) : getRelativeImagePath(bannerImages.desktopImage) }}
        bannerImages={bannerImages}
        {...rest}
      />
      {props.breadcrumb}
    </>
  );
}

export default memo(withErrorHandler(LandingPageBanner));
